import { TrackAutoLoginMeta } from 'types/store/TrackLoginMeta';
import { GenericResponse } from 'types/GenericResponse';
import { createAsyncReducer } from 'utils/Redux';

import { autoTrackLoginAction } from '../actions';

export default createAsyncReducer<TrackAutoLoginMeta, GenericResponse>(
  autoTrackLoginAction,
);
